import { useEffect, useMemo } from "react";
import AutocompleteFormik from "../../../../../common/components/form/AutocompleteFormik";
import { getIn, useFormikContext } from "formik";

type Props = {
  name: string;
  className?: string;
};

export function AvailableVehicleRegisterTypesFormik(props: Props) {
  const { values, setFieldValue } = useFormikContext();
  const currentType = getIn(values, props.name);
  const currentComboboxValue = getIn(values, `${props.name}-combobox`);

  const options = useMemo(() => {
    const dataOptions = [
      { label: "Frente do veículo" },
      { label: "Lateral direita do veículo" },
      { label: "Lateral esquerda do veículo" },
      { label: "Traseira do veículo" },
      { label: "Odometro" },
      { label: "Foto com o cliente" },
      { label: "Print do real condutor / aceite do real condutor" },
    ];
    return dataOptions;
  }, []);

  useEffect(() => {
    if (currentComboboxValue && currentType !== currentComboboxValue.label) {
      setFieldValue(props.name, currentComboboxValue.label);
    }
  }, [currentComboboxValue]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (currentType !== (currentComboboxValue && currentComboboxValue.label)) {
      setFieldValue(`${props.name}-combobox`, { label: currentType });
    }
  }, [currentType]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AutocompleteFormik
      className={props.className}
      label="Tipo de registro:"
      name={`${props.name}-combobox`}
      valueProperty="label"
      options={options}
      allowNewItem={true}
    />
  );
}
